import {FilterObject} from "./filter-object";

export class TarificationFilter extends FilterObject<any> {

  public filter(itemToFiltre: any): boolean {
    return this.doFilter(itemToFiltre, this.field, this.values);
  }

  public doFilter(itemToFiltre: any, field: any, value: any): boolean {
    let comp;
    if (typeof (value) == "number") {
      if (itemToFiltre[field]) {
        comp = itemToFiltre[field];
        comp = parseInt(comp);
        return comp == value;
      } else {
          return false;
      }
    } else if (value != null && value != undefined) {
        return false;
    }
    return true;
  }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/filter/filters/tarification.filter.ts